module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento20.293511f8.svg";